<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading"></PulseLoader>
        </div>
        <div v-if="!loading" class="row">
            <div class="col-md-12 col-sm-12 ">
                <div class="">
                    <div class="x_panel">
                        <h2 class="float-left">Other Consumption History</h2>
                        <ul class="nav navbar-right panel_toolbox align-right">
                            <li v-if="isPermissionExist(PERMISSIONS.ITEM_OTHER_CONSUMPTION_HISTORY_PRINT)">
                              <button @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                                <i class="fa fa-print" v-if="!isPrinting"></i>
                                <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                                {{ isPrinting ? 'Printing...' : 'Print' }}
                              </button>
                            </li>
                          <li v-if="isPermissionExist(PERMISSIONS.ITEM_CRITICAL_EQUIPMENT_PRINT)">
                            <vue-excel-xlsx
                              ref="excel"
                              :data="excelData"
                              :columns="excelHeader"
                              :file-name="'Other Consumption History'"
                              :file-type="'xlsx'"
                              :sheet-name="'sheetname'"
                              :disabled="isPrinting"
                              class="btn btn-primary btn-sm float-right"
                            >
                              <div
                                @click.prevent="handleExportPrint('excel')"
                              >
                                <i class="fa fa-file-excel-o"></i>
                                {{ isPrinting ? 'Preparing...' : 'Excel' }}
                              </div>
                            </vue-excel-xlsx>
                          </li>
                            <li>
                                <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                            </li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card">
                                <div class="card-body">
                                    <form role="form" action="#" @submit="getData" class="searchForm">
                                        <div class="x_panel">
                                            <div class="x_content">
                                                <div class="row justify-content-center">
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <label>Vessel</label>
                                                            <select required class="form-control" v-model="formData.vessel">
                                                                <option value="" selected>Select Vessel</option>
                                                                <option v-for="(row, key) in vessels" v-bind:value="{ id: row?.id, name: row?.name }">{{row?.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 mx-2">
                                                        <div class="form-group">
                                                            <label>Date From</label>
                                                            <DatePicker type="date" v-model="formData.dateFrom" valueType="format"></DatePicker>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 mx-2">
                                                        <div class="form-group">
                                                            <label>Date To</label>
                                                            <DatePicker type="date" v-model="formData.dateTo" valueType="format"></DatePicker>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <button style="margin-top: 26px" type="submit" class="btn btn-success btn-sm">Search</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <div class="card-box table-responsive">
                                        <p class="text-muted font-13 m-b-30"></p>
                                        <ItemTable :items="items"/>
                                        <div id="printArea" style="display: none">
                                            <div style="text-align: center;line-height: 20px;">
                                                <h2 style="line-height: 10px;">{{ appName }}</h2>
                                                <h4 style="line-height: 10px;">Vessel Name: {{this.vessel_name}}</h4>
                                                <div style="line-height: 10px;" class="font-weight-bold">Item List</div>
                                                <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                                <ItemTable :items="items" :isPrinting="true"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

    import moment from 'moment';
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import auth from '../../../auth'
    import ItemTable from "@/components/Item/TopTenConsumeItem/ItemTable.vue";
    import PermissionsMixin from "@/mixin/permissionsMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import printMixin from "@/mixin/printMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import {apiPrintData} from "@/utils/print";

    export default {
        mixins: [PermissionsMixin, goBackButtonMixin, printMixin],
        name: 'TopTenConsumeItem',
        components: {
            ItemTable,
            PulseLoader,
            DatePicker
        },
        data() {
            return {
                loading: false,
                appName: process.env.VUE_APP_NAME,
                permissions: auth.getPermissionData(),
                vesselId: auth.getVesselId(),
                vessel_name: auth.getVesselName(),
                items: [],
                vessels: null,
                isPrinting: false,
                excelHeader: [],
                excelData: [],
                formData: {
                    vessel: {
                        id: auth.getVesselId(),
                        name: ''
                    },
                    dateFrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                    dateTo: moment().format('YYYY-MM-DD'),
                }
            }
        },
        mounted() {
            this.getVessel();
            this.getData();
        },
        methods: {
            getData: function (e) {
                if (e !== undefined) {
                    e.preventDefault()
                }
                this.loading = true;
                let params = {
                    vessel_id: this.formData.vessel ? this.formData.vessel.id : null,
                    date_from: this.formData.dateFrom,
                    date_to: this.formData.dateTo
                };
                this.$http.get('/api/top-ten-consume-item', {params}).then((response) => {
                    this.loading = false;
                    if (response.data) {
                        this.items = response.data.success;
                    }
                }).catch((error) => {
                    this.loading = false;
                    let response = error.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                });
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Name': `${item?.name || ''}`,
                'Total Consume': `${item?.total_consume_qty || ''}`,
                'ROB': `${item?.rob || ''}`,
              });
            });
            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);

            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return false;
            }
            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
            return true;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.formData.vessel ? this.formData.vessel.id : null,
                date_from: this.formData.dateFrom,
                date_to: this.formData.dateTo
              };

              const res = await this.$http.get('/api/top-ten-consume-item', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Other Consumption History');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                const excel = this.excelExport(dataList);

                if (!excel) {
                  this.isPrinting = false;
                  return;
                }

                this.$nextTick(() => {
                  setTimeout(() => {
                    this.$refs.excel.$el.click();
                    this.isPrinting = false;
                  }, 50);
                });
              }


            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            getVessel() {
                let params = {
                    is_all: 1
                };
                this.$http.get('/api/vessel', {params}).then(response => {
                    this.vessels = response.data.success.vessel;
                    const selectedVessel = this.vessels.find(vessel => vessel.id == this.vesselId);
                    if (selectedVessel) {
                        this.formData.vessel = {
                            id: selectedVessel.id,
                            name: selectedVessel.name
                        };
                    }
                }).catch(e => {
                    console.log(e)
                })
            }

        }
    }
</script>
<style>

</style>
